import { Typography, Button } from '@mui/material';
import { Box } from '@mui/system';
import { LoginView } from '@pages/Login/constants';
import { useNavigate } from 'react-router-dom';

export const IndicationWelcomeMessage = ({ view }: { view?: LoginView }) => {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 430 }}>
      <Typography
        variant='h3'
        sx={{
          fontWeight: 600,
          mb: 1,
        }}
      >
        Welcome! Thanks for your interest in an indication from{' '}
        <Box component='span' sx={{ whiteSpace: 'nowrap' }}>
          LIO Specialty.
        </Box>
      </Typography>
      {view !== LoginView.SIGNUP ? (
        <Typography variant='body' mt={2}>
          To continue to your indication, please sign in with your LIO account, or{' '}
          <Button
            color='secondary'
            variant='text'
            disableRipple
            onClick={() => {
              navigate('/sign-up');
            }}
            sx={sxStyles.inlineButton}
          >
            create an account
          </Button>{' '}
          if you aren{`'`}t registered.
        </Typography>
      ) : (
        <Typography variant='body' mt={2}>
          To continue to your indication, please create a LIO account, or{' '}
          <Button
            color='secondary'
            variant='text'
            disableRipple
            onClick={() => {
              navigate('/login');
            }}
            sx={sxStyles.inlineButton}
          >
            sign in
          </Button>{' '}
          if you are already registered.
        </Typography>
      )}
    </Box>
  );
};

const sxStyles = {
  inlineButton: {
    fontSize: 'inherit',
    margin: 0,
    padding: 0,
    mt: '-2px',
    display: 'inline',
  },
};
